export default __webpack_public_path__ + "static/media/sepulcherofthewyrm.7c9650ab.jpg";